var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from "../api";
import { Progress } from "../component/progress";
import { Spinner } from "../component/spinner";
import { utilities } from "../utilities/utilities";
import { Element } from "../element/element";
import { Modal } from "../component/modal";
var TaskProgress = /** @class */ (function () {
    function TaskProgress(args) {
        this.element = null;
        this.messageElement = null;
        this.progress = 0;
        this.message = "";
        this.progressInstance = new Progress(args);
    }
    Object.defineProperty(TaskProgress.prototype, "progressElement", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.querySelector) === null || _b === void 0 ? void 0 : _b.call(_a, '.progress-bar');
        },
        enumerable: false,
        configurable: true
    });
    TaskProgress.prototype.updateProgress = function () {
        if (!this.progressElement)
            return;
        this.progressElement.style.width = this.progress + "%";
        this.progressElement.innerText = "".concat(this.progress, "%");
    };
    TaskProgress.prototype.updateMessage = function () {
        if (this.messageElement)
            this.messageElement.innerHTML = this.message;
    };
    TaskProgress.prototype.update = function (task) {
        if (!!task) {
            task.progress = Math.round((task.progress * 100));
            this.progress = task.progress;
            this.message = "".concat(!!task.description ? task.description : "Processing...");
        }
        else {
            this.progress = 0;
            this.message = "Processing...";
        }
        this.updateProgress();
        this.updateMessage();
    };
    TaskProgress.prototype.compose = function () {
        this.messageElement = utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            <div id=\"message\" class=\"small fw-light pulse mt-3\">", "</div>\n        "], ["\n            <div id=\"message\" class=\"small fw-light pulse mt-3\">", "</div>\n        "])), this.message);
        this.element = $$.util.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            <div>\n                ", "\n                ", "\n            </div>\n        "], ["\n            <div>\n                ", "\n                ", "\n            </div>\n        "])), this.progressInstance.render(), this.messageElement);
        return this.element;
    };
    TaskProgress.prototype.render = function () {
        if (this.progressInstance.container) {
            this.progressInstance.container.append(this.compose());
        }
        else {
            return this.compose();
        }
    };
    return TaskProgress;
}());
// Meta class to encapsulate either a Task or a simple API fetch operation.
//If it's a task there will be a url, the url is and the result will be a IPackageResponse from which we obtain the taskId, if there is an initial spinner set we show the spinner until we get the taskId. Once we have the task id we instantiate a Task with the taskId and the progress args if any. The Task will handle the polling and progress updates. The Meta class will just return the Task instance to the caller. Once the Task is completed the caller will have to handle the result via the Task events.
var Meta = /** @class */ (function () {
    function Meta(args) {
        var _a, _b;
        this.args = args;
        this.inModal = false;
        this.modalInstance = null;
        this.cancelled = false;
        this.initialMessage = "";
        this.type = args.type;
        if (args.spinner && !this.inModal) {
            this.spinner = new Spinner(args.spinner);
        }
        if (!args.spinner) {
            this.spinner = null;
        }
        if (args.initialMessage) {
            this.initialMessage = args.initialMessage;
        }
        if (this.type == "task" && args.progress) {
            this.progress = new TaskProgress(args.progress);
            this.taskEvents = args.events;
        }
        console.log((_a = this.args.progress) === null || _a === void 0 ? void 0 : _a.modal, 'modal?');
        if ((_b = args.progress) === null || _b === void 0 ? void 0 : _b.modal) {
            this.inModal = true;
        }
    }
    Meta.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                // this.spinner = new Spinner({});
                if (this.inModal) {
                    if (!this.spinner && this.initialMessage) {
                        this.progress.message = this.initialMessage;
                    }
                    this.modalInstance = new Modal({
                        composer: {
                            classes: {
                                header: 'd-flex align-items-center h4'
                            },
                            header: utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                            <div class=\"d-flex align-items-center gap-2\">\n                                Progress\n                            </div>\n                        "], ["\n                            <div class=\"d-flex align-items-center gap-2\">\n                                Progress\n                            </div>\n                        "]))),
                            body: (_b = (_a = this.spinner) === null || _a === void 0 ? void 0 : _a.render()) !== null && _b !== void 0 ? _b : utilities.html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                            <div>\n                                ", "\n                            </div>\n                        "], ["\n                            <div>\n                                ", "\n                            </div>\n                        "])), this.progress.compose()),
                            footer: utilities.html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                            <div class=\"d-flex justify-content-end\">\n                                ", "\n                   \n                            </div>\n                        "], ["\n                            <div class=\"d-flex justify-content-end\">\n                                ", "\n                   \n                            </div>\n                        "])), new Element({
                                composer: {
                                    content: utilities.html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                                            <button type=\"button\" class=\"btn btn-light\" data-bs-dismiss=\"modal\">Close</button>\n                                        "], ["\n                                            <button type=\"button\" class=\"btn btn-light\" data-bs-dismiss=\"modal\">Close</button>\n                                        "])))
                                },
                                events: {
                                    click: function () {
                                        var _a;
                                        (_a = _this.modalInstance) === null || _a === void 0 ? void 0 : _a.hide();
                                    }
                                }
                            }).render())
                        },
                        events: {
                            hide: function () {
                                _this.cancelled = true;
                            }
                        }
                    });
                    (_c = this.modalInstance) === null || _c === void 0 ? void 0 : _c.show();
                }
                else {
                    (_d = this.spinner) === null || _d === void 0 ? void 0 : _d.render();
                }
                if (this.type === 'fetch') {
                    return [2 /*return*/, this.fetch()];
                }
                return [2 /*return*/, this.initTask()];
            });
        });
    };
    Meta.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, , 2, 3]);
                        return [4 /*yield*/, new API(__assign(__assign({}, this.args.api), { events: this.args.events })).invoke()];
                    case 1: return [2 /*return*/, _d.sent()];
                    case 2:
                        (_c = (_b = (_a = this.spinner) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.remove) === null || _c === void 0 ? void 0 : _c.call(_b);
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------- TASK ---------------- */
    Meta.prototype.initTask = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0: return [4 /*yield*/, new API(__assign({}, this.args.api)).invoke()];
                    case 1:
                        response = _k.sent();
                        this.taskId = response === null || response === void 0 ? void 0 : response.taskId;
                        if (!this.taskId) {
                            (_c = (_b = (_a = this.spinner) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.remove) === null || _c === void 0 ? void 0 : _c.call(_b);
                            throw new Error('No taskId returned from task creation');
                        }
                        (_f = (_e = (_d = this.spinner) === null || _d === void 0 ? void 0 : _d.element) === null || _e === void 0 ? void 0 : _e.remove) === null || _f === void 0 ? void 0 : _f.call(_e);
                        if (this.inModal) {
                            console.log(this.progress.compose());
                            console.log(this.modalInstance.element.querySelector('.modal-body'));
                            if (this.spinner) {
                                (_h = (_g = this === null || this === void 0 ? void 0 : this.spinner) === null || _g === void 0 ? void 0 : _g.element) === null || _h === void 0 ? void 0 : _h.remove();
                                this.modalInstance.element.querySelector('.modal-body').appendChild(this.progress.compose());
                            }
                            else {
                                this.modalInstance.element.querySelector('.modal-body').innerHTML = '';
                                this.modalInstance.element.querySelector('.modal-body').appendChild(this.progress.compose());
                            }
                        }
                        else {
                            (_j = this.progress) === null || _j === void 0 ? void 0 : _j.render();
                        }
                        // 2. start polling
                        this.poll();
                        return [2 /*return*/];
                }
            });
        });
    };
    Meta.prototype.poll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var task;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.taskId)
                            return [2 /*return*/];
                        return [4 /*yield*/, new API({
                                url: "/api/task/status/".concat(this.taskId),
                                responseType: 'json',
                                events: {
                                    success: function (_task) { var _a; return (_a = _this.progress) === null || _a === void 0 ? void 0 : _a.update(_task); }
                                }
                            }).invoke()];
                    case 1:
                        task = _a.sent();
                        if (this.cancelled)
                            return [2 /*return*/];
                        switch (task.state) {
                            case 'Completed':
                                return [2 /*return*/, this.completed()];
                            case 'Failed':
                                return [2 /*return*/, this.failed(task)];
                            case 'Pending':
                                break;
                            case 'Running':
                                break;
                        }
                        setTimeout(function () { return _this.poll(); }, 500);
                        return [2 /*return*/];
                }
            });
        });
    };
    Meta.prototype.completed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.taskId)
                            return [2 /*return*/];
                        return [4 /*yield*/, new API({
                                url: "/api/task/result/".concat(this.taskId),
                                responseType: 'json',
                                events: {
                                    success: function (result) {
                                        var _a, _b;
                                        console.log(result);
                                        if (_this.inModal) {
                                            _this.modalInstance.element.querySelector('.modal-header').classList.add('text-success');
                                            _this.modalInstance.element.querySelector('.modal-header').innerHTML = "\n                            <i class=\"fa-solid fa-check-circle me-2 fa-2x\"></i>\n                            <h5 class=\"modal-title\">Success</h5>\n                        ";
                                            _this.modalInstance.element.querySelector('.modal-body').innerHTML = "\n                            <div class=\"fst-italic mb-1\">\n                                ".concat(result.description, "\n                            </div>\n                            <div class=\"small opacity-75\">\n                                This modal will automatically close in 5 seconds.\n                            </div>\n                        ");
                                            setTimeout(function () {
                                                var _a;
                                                (_a = _this.modalInstance) === null || _a === void 0 ? void 0 : _a.hide();
                                            }, 5000);
                                        }
                                        else {
                                            (_b = (_a = _this.taskEvents) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.call(_a, result);
                                        }
                                    }
                                }
                            }).invoke()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Meta.prototype.failed = function (taskResponse) {
        var _a, _b;
        if (this.inModal) {
            this.modalInstance.element.querySelector('.modal-header').classList.add('text-danger');
            this.modalInstance.element.querySelector('.modal-header').innerHTML = "\n                <i class=\"fa-solid fa-exclamation-circle me-2 fa-2x\"></i>\n                <h5 class=\"modal-title\">Error</h5>\n            ";
            this.modalInstance.element.querySelector('.modal-body').innerHTML = "\n                <div>\n                    <h5 class=\"fw-light mb-3\">Error list</h5>\n                    <div class=\"d-flex flex-column gap-2\">\n                        - ".concat(taskResponse.description, "\n                    </div>\n                </div>\n                ");
        }
        else {
            (_b = (_a = this.taskEvents) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, taskResponse);
        }
        // this.args.task?.result.failed?.();
    };
    return Meta;
}());
export { Meta };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
/**
 * Task class to manage asynchronous tasks with progress tracking and result handling.
 */
// export class Task {
//     taskId: string;
//     task?: ITaskResponse;
//     progress?: TaskProgress;
//     resultEvents: ITaskResultEvents;
//     constructor(args: ITaskArgs) {
//         this.taskId = args.taskId;
//         if (args.progress) {
//             this.progress = new TaskProgress(args.progress);
//         }
//         this.resultEvents = args.result;
//     }
//     async init(): Promise<void> {
//         await this.pollStatus();
//     }
//     private async pollStatus(): Promise<void> {
//         this.task = await new API({
//             url: `/api/task/status/${this.taskId}`,
//             responseType: 'json',
//             events: {
//                 success: () => this?.progress?.update(this.task)
//             }
//         }).invoke() as ITaskResponse;
//         console.log(this.task);
//         if (this.task.state === 'Completed') {
//             await this.onCompleted();
//             return;
//         }
//         if (this.task.state === 'Failed') {
//             await this.onFailed();
//             return;
//         }
//         setTimeout(() => {
//             this.pollStatus();
//         }, 500);
//     }
//     private async onCompleted(): Promise<void> {
//         await new API({
//             url: `/api/task/result/${this.taskId}`,
//             responseType: 'json',
//             events: {
//                 success: this.resultEvents.completed
//             }
//         }).invoke();
//     }
//     private async onFailed(): Promise<void> {
//         if (this.resultEvents.failed) {
//             console.log('failed')
//             this.resultEvents.failed();
//         }
//     }
// }
